import { render, staticRenderFns } from "./FbaInventoryTable.vue?vue&type=template&id=5282b404&scoped=true&"
import script from "./FbaInventoryTable.vue?vue&type=script&lang=js&"
export * from "./FbaInventoryTable.vue?vue&type=script&lang=js&"
import style0 from "./FbaInventoryTable.vue?vue&type=style&index=0&id=5282b404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5282b404",
  null
  
)

export default component.exports